import { FC } from "react";
import { AjinomotoTwoStepValidation } from "../AjinomotoTwoStepValidation";

/**
 * High risk cows insight validation
 * @param {React.PropsWithChildren<{}>} props
 * @return {JSX.Element}
 * @constructor
 */
export const AjinomotoHighRiskCowsInsightValidation: FC = (props) => (
  <AjinomotoTwoStepValidation {...props} />
);
